import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Loading } from 'tdesign-react';
import CountUp from 'react-countup';
import { fetchTopicOverview } from '@/slices/kopTopicSlice';
import SummaryPanel from '@/components/Cluster/SummaryPanel';
import { content } from '@/components/Cluster/TopicTip';
import HealthGaugeBlock from '@/pages/KOPCluster/components/HealthGaugeBlock';

function Summary({ overview, fetchTopicOverview, loading }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');

  useEffect(() => {
    if (clusterName) {
      fetchTopicOverview(clusterName);
    }
  }, [clusterName, fetchTopicOverview]);

  const items = [
    {
      title: 'Topic',
      icon: 'topic',
      info: (
        <>
          <CountUp end={overview.totalTopicPartitionCount} duration={0.4} />/
          <CountUp end={overview.totalTopicCount} duration={0.4} />
        </>
      ),
      unit: '个',
      tip: content,
    },
    {
      title: 'PartitionNoLeader',
      icon: 'producer',
      info: <CountUp end={overview.totalPartitionNoLeaderCount} duration={0.4} />,
      unit: '个',
    },
    {
      title: '< Min ISR',
      icon: 'consumer',
      info: <CountUp end={overview.totalUnderMinIsrCount} duration={0.4} />,
      unit: '个',
    },
    {
      title: '= Min ISR',
      icon: 'subscription',
      info: <CountUp end={overview.totalEqualMinIsrCount} duration={0.4} />,
      unit: '个',
    },
    {
      title: 'PartitionURP',
      icon: 'other2',
      info: <CountUp end={overview.totalPartitionUrpCount} duration={0.4} />,
      unit: '个',
    },
  ];
  return (
    <Loading loading={loading} size='small'>
      <SummaryPanel
        shadow
        items={items}
        prepend={
          <HealthGaugeBlock mode='Topic' style={{ padding: '12px 20px 0 6px', width: 210 }} />
        }
      />
    </Loading>
  );
}

export default connect(
  (state) => ({
    overview: state.kopTopic.overview,
    loading: state.kopTopic.loading,
  }),
  {
    fetchTopicOverview,
  },
)(Summary);
